import { SunriseArc } from "./SunriseArc";

export function ScreenWelcome() {
  return (
    <div
      className="mfm-screen"
      data-mode="light"
      data-accent="burgundy"
      style={{
        width: "100%",
        height: "100%",
        padding: "120px 32px 48px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: 32 }}>
        <SunriseArc size={64} />
        <div className="eyebrow">My First Marathon</div>
        <div
          className="serif"
          style={{ fontSize: 44, lineHeight: 1.02, letterSpacing: "-0.025em", color: "var(--text)" }}
        >
          You&apos;re going to
          <br />
          run a marathon.
        </div>
        <div
          style={{
            fontFamily: "var(--ui)",
            fontSize: 15,
            lineHeight: 1.5,
            color: "var(--text-2)",
            maxWidth: 280,
          }}
        >
          Eighteen weeks. Forty-six runs. One marathon. We&apos;ll get you to the start line.
        </div>
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        <button type="button" className="mfm-btn-primary">
          Begin
        </button>
        <div
          style={{
            textAlign: "center",
            fontFamily: "var(--ui)",
            fontSize: 12,
            color: "var(--text-3)",
            letterSpacing: "0.02em",
          }}
        >
          Seven days free. Cancel anytime.
        </div>
      </div>
    </div>
  );
}
